var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-to-platform',_vm._b({attrs:{"platform":"google"},on:{"essays-exported":function($event){return _vm.$emit('essays-exported')}}},'export-to-platform',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }